<template>
    <div>
        <div class="d-lg-flex align-items-center ">
            <p class="h6">
                Start a new collection. Securely collect and manage group funds within minutes!
            </p>
            <!-- <router-link to="/create" tag="button" class="btn btn-moneypool-sm ml-auto">Create a new pool</router-link> -->
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="border-0">
                    <div class="">
                        <nav class="">
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link active" id="nav-active-tab" href="" data-toggle="tab" role="tab" aria-controls="nav-pools" aria-selected="true" @click="navigatePool('all')">All Pools <span class="badge badge-light">({{ pools.length}})</span></a>
                                <!-- <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-active" role="tab" aria-controls="nav-active-polls" aria-selected="false" @click="navigatePool('active')">Active Pools</a>
                                <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-closed" role="tab" aria-controls="nav-closed-polls" aria-selected="false" @click="navigatePool('closed')">Closed Pools</a> -->
                            </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">
                            <div class="tab-pane fade show active py-4" id="" role="tabpanel">
                                <component 
                                    :is="poolsComponent"
                                    :pool_type="pool_type"
                                    :pools="pools"
                                    >
                                </component>
                            </div>

                            <div class="d-flex justify-content-center align-items-center" v-if="loading_state">
                                <p class="py-5">loading...</p>
                            </div>

                        </div>
                        <div class="card border-0 shadow-sm" v-if="! loading_state && pools.length == 0">
                            <div class="card-body">
                                <div class="d-flex justify-content-center align-items-center" style="min-height:70vh">
                                    <p class=""> 
                                        <span class="fa fa-folder-open"></span>
                                        No pools at this time.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AllPools from '@/components/AllPools';
import ActivePools from '@/components/ActivePools';
import ClosedPools from '@/components/ClosedPools';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'mypools',
    components: { AllPools, ActivePools, ClosedPools },
    data() {
        return {
            pool_type: 'all',
            loading: false
        }
    },
    computed: {
        ...mapGetters([
            'userProfile',
            'pools'
        ]),
        ...mapState([
            'loading_state'
        ]),

        poolsComponent() {
            if ( this.pool_type == 'all' ) {
                return 'AllPools'
            } else if (this.pool_type == 'active') {
                return 'ActivePools'
            } else {
                return 'ClosedPools'
            }
        }
    },
    created() {
        this.$store.dispatch('getPools');
    },
    methods: {
        navigatePool(type) {
            this.pool_type = type;
        },
    },

}
</script>

<style>

</style>